import { styled } from "styled-components";
import { Label } from "./AccountBalanceInput";
import { ReactNode } from "react";

interface ReceiptComponentProps {
  title: string;
  description: ReactNode;
}
const ReceiptComponent: React.FC<ReceiptComponentProps> = ({
  title,
  description,
}) => {
  return (
    <Receipt>
      <div>
        <Title>{title}</Title>
      </div>
      <div>
        <Label>{description}</Label>
      </div>
    </Receipt>
  );
};

export default ReceiptComponent;

export const Title = styled.p`
  color: #868686;
  font-size: 14px;
  font-weight: 400;
`;
export const Receipt = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10rem;
`;
